export const useLoanApplicationLink = (
	dossierDisplayId: number,
	loanApplicationId: string,
) => ({
	name: "LoanApplicationDetailsPage",
	params: {
		dossierDisplayId,
		loanApplicationId,
	},
});
